/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * application
 * OpenAPI spec version: 1.0.0-20260504-120553-8e977429
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
export interface AddParcelRequest {
  barcode: string;
  postalCode: string;
}

export interface AddParcelResponse {
  amountOfAddedParcels: number;
  addedParcelIds?: string[];
  addSucceeded: boolean;
}

export interface Address {
  countryCode: string;
  city: string;
  postalCode: string;
  street: string;
  houseNumber: string;
  houseNumberSuffix: string;
  lines?: string[];
}

export interface AuthenticationError {
  key: string;
  message: string;
}

export interface Avondwinkel { [key: string]: unknown }

export interface BusinessPoint { [key: string]: unknown }

export interface Buurtpunt { [key: string]: unknown }

export interface CancelParcelRequest {
  barcode: string;
  postalCode: string;
}

export interface CancelParcelResponse {
  cancelSucceeded: boolean;
}

export interface ClearTimeIndication { [key: string]: unknown }

export interface ClosurePeriod {
  type: string;
  fromDate: string;
  toDate: string;
}

export interface DateIndication {
  date: string;
}

export interface HMacAuthToken {
  payload: string;
}

export interface IntervalIndication {
  start: string;
  end: string;
}

export interface Location {
  name?: string;
  address?: Address;
  locationType: string;
  code?: string;
  openingTimes?: OpeningTime[];
  closurePeriods?: ClosurePeriod[];
  latitude?: number;
  longitude?: number;
  servicePointFormat?: ServicePointFormat;
}

export interface LockersDHL { [key: string]: unknown }

export interface LockersDeBuren { [key: string]: unknown }

export interface LockersSmartmile { [key: string]: unknown }

export interface MomentIndication {
  moment: string;
}

export interface NotFoundError {
  key: string;
  message: string;
}

export interface OpeningTime {
  timeFrom: string;
  timeTo: string;
  weekDay: number;
}

export interface ParcelResponse {
  parcels?: ReceiverParcelSummary[];
  postalCodeValidations?: PostalCodeValidation[];
}

export interface ParcelStation { [key: string]: unknown }

export interface PostalCodeValidation {
  senderName?: string;
  parcelCount: number;
  attemptsRemaining: number;
}

export interface Receiver {
  name?: string;
  address?: Address;
  email?: string;
  phone?: string;
  fax?: string;
  contactName?: string;
}

export interface ReceiverParcelSummary {
  parcelId: string;
  status: string;
  category: string;
  destination?: Location;
  receiver?: Receiver;
  sender?: Sender;
  origin?: Location;
  receivingTimeIndication?: TimeIndication;
  barcode?: string;
  intervenable: boolean;
  isRegistered: boolean;
  isReturnedToShipper: boolean;
  isReturn: boolean;
  receivedDaysAgo?: number;
  returnedDaysAgo?: number;
  isClimateNeutralDelivery: boolean;
  undeliverableSinceDaysAgo?: number;
  returnable: boolean;
  hasDeliveryCode: boolean;
  hasServicePointPickupCode: boolean;
  hasLockerCode: boolean;
  orderId?: string;
  createdAt: string;
}

export interface Sender {
  name?: string;
  address?: Address;
  email?: string;
  phone?: string;
  fax?: string;
  contactName?: string;
}

export type ServicePointFormat = Avondwinkel | BusinessPoint | Buurtpunt | LockersDHL | LockersDeBuren | LockersSmartmile | ParcelStation | Shop | Unknown;

export interface Shop { [key: string]: unknown }

export type TimeIndication = ClearTimeIndication | DateIndication | IntervalIndication | MomentIndication;

export interface Unknown {
  value: string;
}

export type GetParcelsParams = {
tab?: GetParcelsTab;
};

export type GetParcelsTab = typeof GetParcelsTab[keyof typeof GetParcelsTab];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetParcelsTab = {
  incoming: 'incoming',
  outgoing: 'outgoing',
} as const;

export type GetTrackTraceParams = {
key: string;
role?: string;
firstEvents?: number;
uuid?: string;
};

export const useGetParcelsHook = () => {
        const getParcels = useMutator<ParcelResponse>();

        return useCallback((
    params?: GetParcelsParams,
 signal?: AbortSignal
) => {
        return getParcels(
          {url: `/parcels`, method: 'GET',
        params, signal
    },
          );
        }, [getParcels])
      }
    

export const getGetParcelsQueryKey = (params?: GetParcelsParams,) => {
    return [`/parcels`, ...(params ? [params]: [])] as const;
    }

    
export const useGetParcelsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError = string | AuthenticationError>(params?: GetParcelsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParcelsQueryKey(params);

  const getParcels =  useGetParcelsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>> = ({ signal }) => getParcels(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>>
export type GetParcelsQueryError = string | AuthenticationError


export function useGetParcels<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError = string | AuthenticationError>(
 params: undefined |  GetParcelsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcels<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError = string | AuthenticationError>(
 params?: GetParcelsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcels<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError = string | AuthenticationError>(
 params?: GetParcelsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcels<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError = string | AuthenticationError>(
 params?: GetParcelsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetParcelsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostParcelHook = () => {
        const postParcel = useMutator<AddParcelResponse>();

        return useCallback((
    addParcelRequest: AddParcelRequest,
 signal?: AbortSignal
) => {
        return postParcel(
          {url: `/parcels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addParcelRequest, signal
    },
          );
        }, [postParcel])
      }
    


export const usePostParcelMutationOptions = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>, TError,{data: AddParcelRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>, TError,{data: AddParcelRequest}, TContext> => {

const mutationKey = ['postParcel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postParcel =  usePostParcelHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>, {data: AddParcelRequest}> = (props) => {
          const {data} = props ?? {};

          return  postParcel(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostParcelMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>>
    export type PostParcelMutationBody = AddParcelRequest
    export type PostParcelMutationError = string | AuthenticationError | NotFoundError

    export const usePostParcel = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>, TError,{data: AddParcelRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostParcelHook>>>,
        TError,
        {data: AddParcelRequest},
        TContext
      > => {

      const mutationOptions = usePostParcelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteParcelHook = () => {
        const deleteParcel = useMutator<null>();

        return useCallback((
    parcelId: string,
 ) => {
        return deleteParcel(
          {url: `/parcels/${parcelId}`, method: 'DELETE'
    },
          );
        }, [deleteParcel])
      }
    


export const useDeleteParcelMutationOptions = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>, TError,{parcelId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>, TError,{parcelId: string}, TContext> => {

const mutationKey = ['deleteParcel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteParcel =  useDeleteParcelHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>, {parcelId: string}> = (props) => {
          const {parcelId} = props ?? {};

          return  deleteParcel(parcelId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteParcelMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>>
    
    export type DeleteParcelMutationError = string | AuthenticationError | NotFoundError

    export const useDeleteParcel = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>, TError,{parcelId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteParcelHook>>>,
        TError,
        {parcelId: string},
        TContext
      > => {

      const mutationOptions = useDeleteParcelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useCancelParcelHook = () => {
        const cancelParcel = useMutator<CancelParcelResponse>();

        return useCallback((
    cancelParcelRequest: CancelParcelRequest,
 signal?: AbortSignal
) => {
        return cancelParcel(
          {url: `/parcels/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelParcelRequest, signal
    },
          );
        }, [cancelParcel])
      }
    


export const useCancelParcelMutationOptions = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>, TError,{data: CancelParcelRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>, TError,{data: CancelParcelRequest}, TContext> => {

const mutationKey = ['cancelParcel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const cancelParcel =  useCancelParcelHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>, {data: CancelParcelRequest}> = (props) => {
          const {data} = props ?? {};

          return  cancelParcel(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelParcelMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>>
    export type CancelParcelMutationBody = CancelParcelRequest
    export type CancelParcelMutationError = string | AuthenticationError | NotFoundError

    export const useCancelParcel = <TError = string | AuthenticationError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>, TError,{data: CancelParcelRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCancelParcelHook>>>,
        TError,
        {data: CancelParcelRequest},
        TContext
      > => {

      const mutationOptions = useCancelParcelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetTrackTraceHook = () => {
        const getTrackTrace = useMutator<string>();

        return useCallback((
    params: GetTrackTraceParams,
 signal?: AbortSignal
) => {
        return getTrackTrace(
          {url: `/track-trace`, method: 'GET',
        params, signal
    },
          );
        }, [getTrackTrace])
      }
    

export const getGetTrackTraceQueryKey = (params?: GetTrackTraceParams,) => {
    return [`/track-trace`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTrackTraceQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError = string | AuthenticationError | NotFoundError>(params: GetTrackTraceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackTraceQueryKey(params);

  const getTrackTrace =  useGetTrackTraceHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>> = ({ signal }) => getTrackTrace(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackTraceQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>>
export type GetTrackTraceQueryError = string | AuthenticationError | NotFoundError


export function useGetTrackTrace<TData = Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError = string | AuthenticationError | NotFoundError>(
 params: GetTrackTraceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackTrace<TData = Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError = string | AuthenticationError | NotFoundError>(
 params: GetTrackTraceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackTrace<TData = Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError = string | AuthenticationError | NotFoundError>(
 params: GetTrackTraceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTrackTrace<TData = Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError = string | AuthenticationError | NotFoundError>(
 params: GetTrackTraceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTrackTraceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTrackTraceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
